import React from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

export const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
  <button
    onClick={onClick}
    className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-black/40 hover:bg-black/60 p-2 rounded-full text-white"
    aria-label="Previous"
  >
    <MdChevronLeft className="w-6 h-6" />
  </button>
);

export const NextArrow = ({ onClick }: { onClick?: () => void }) => (
  <button
    onClick={onClick}
    className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-black/40 hover:bg-black/60 p-2 rounded-full text-white"
    aria-label="Next"
  >
    <MdChevronRight className="w-6 h-6" />
  </button>
);
